import { AID_STUDIO_STEP } from '../aid-studio-details.constants';

export const getAidStudioListPath = (
  clientId: number,
  isUserView?: boolean
): string =>
  isUserView ? '/aid-studio' : `/admin/clients/${clientId}/aid-studio`;

export const getAidModelDetailsPath = (
  clientId: number,
  modelId: string | number | undefined,
  isUserView?: boolean
): string => `${getAidStudioListPath(clientId, isUserView)}/${modelId}`;

export const getCloneLandingPath = (
  clientId: number,
  newModelId: number,
  isUserView?: boolean
): string => {
  const landingStep = isUserView
    ? AID_STUDIO_STEP.RESULTS
    : AID_STUDIO_STEP.BASIC_INFO;

  return `${getAidModelDetailsPath(
    clientId,
    newModelId,
    isUserView
  )}/${landingStep}`;
};
